import React, { useState } from 'react';
import { Popover, Checkbox } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { toobarTheme } from './ToolbarUtils';
import Styles from './FilterPopover.scss';

const CustomizePopover = ({ id, open, anchorEl, handleClose, item, filterValue, setSortLabel, onChangeFilter, dataCy, setShowCustomize, icon }) => {
    const [draggedItemIndex, setDraggedItemIndex] = useState(null);
    const [Draggable, setDraggable] = useState(false);
    const platform = navigator.platform.toUpperCase();

    const handleDragStart = (index, event) => {
        if (platform.includes('MAC') || platform.includes('LINUX')) {
            event.dataTransfer.dropEffect = 'move';
        }
        event.dataTransfer.setData('text/plain', index);
        event.dataTransfer.effectAllowed = 'move';
        setDraggedItemIndex(index);
    };



    const handleDragOver = (index, event) => {
        if (platform.includes('MAC') || platform.includes('LINUX')) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
        }
        const draggedOverIndex = index;
        if (draggedItemIndex === null || draggedItemIndex === draggedOverIndex) return;
        const reorderedItems = [...item];
        const draggedItem = reorderedItems[draggedItemIndex];
        reorderedItems.splice(draggedItemIndex, 1);
        reorderedItems.splice(draggedOverIndex, 0, draggedItem);
        setShowCustomize(reorderedItems);
        setDraggedItemIndex(draggedOverIndex);
        let filterData = { ...filterValue };
        filterData.customizedColumns = reorderedItems;
        onChangeFilter(filterData);
    };



    const handleDragEnd = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDraggable(false);
        setDraggedItemIndex(null);
    };

    const handleRowClick = (index) => {
        const updatedItems = [...item];
        updatedItems[index].checked = !updatedItems[index].checked;
        let filterData = { ...filterValue };
        filterData.customizedColumns = updatedItems;
        onChangeFilter(filterData);
        setShowCustomize(updatedItems);
    };

    return (
        <ThemeProvider theme={toobarTheme}>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div className={Styles.defaultFilterContainer} data-cy={`${dataCy}-sort`}>
                    <div className={Styles.customizeContainer}>
                        {item.map((i, index) => (
                            <div
                                key={i.key}
                                className={Styles.customizeOptionItem}
                                draggable={Draggable}
                                onDragStart={(event) => handleDragStart(index, event)}
                                onDragOver={(event) => handleDragOver(index, event)}
                                onDragEnd={(event) => handleDragEnd(event)}
                                onClick={(event) => handleRowClick(index, event)}
                            >
                                <div className={Styles.checkboxLabel}>
                                    <Checkbox checked={i.checked} disableRipple />
                                    <span>{i.label}</span>
                                </div>
                                <div className={Styles.hoverIconContainer} onClick={(event) => event.stopPropagation()}
                                    onMouseDown={e => setDraggable(true)}
                                    onMouseUp={e => setDraggable(false)}>
                                    {icon}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Popover >
        </ThemeProvider>
    );
};

export default CustomizePopover;